import type { SchaefflerFormHiddenFieldDTO } from "~/features/cms/types/dto";
import { useFormContext } from "react-hook-form";
import { useResolveValue } from "~/features/cms/schaefflerForm/schaefflerFormHelper";

export type SchaefflerFormHiddenFieldProps = Omit<SchaefflerFormHiddenFieldDTO, "type">;

export const SchaefflerFormHiddenField = (props: SchaefflerFormHiddenFieldProps) => {
  const { register } = useFormContext();
  const value = useResolveValue(props.value);
  return <input type="hidden" {...register(props.name, { value })} />;
};
